<template>
  <div class="uvStatistics">
    <div class="management-search">
      <div class="management-search-1">
        渠道：
        <a-select
          v-model="channel"
          placeholder="请选择渠道"
          class="select-tag"
          allowClear
          :filter-option="false"
          @search="getChannelList"
          showSearch
          @change="query(1)"
        >
          <a-select-option
            v-for="item in channelSelectList"
            :key="item.id"
            :value="item.name"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="management-search-1">
        uv：
        <a-input
          placeholder="请输入uv开始"
          v-model="uvStart"
          @keyup.enter="query(1)"
          allow-clear
        ></a-input>
        —
        <a-input
          placeholder="请输入uv结束"
          v-model="uvEnd"
          @keyup.enter="query(1)"
          allow-clear
        ></a-input>
      </div>
      <div class="management-search-1">
        访问时间：
        <a-date-picker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          v-model="startTime"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="结束时间"
          v-model="endTime"
        />
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="primary" @click="ExportData">导出</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="false"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="registerRate" slot-scope="text, record"> {{ text }}% </span>
    </a-table>
  </div>
</template>
<script>
import api from "../lib/uvStatistics.js";
import analysisApi from "../lib/cityAnalysis.js";
import moment from "moment";

export default {
  name: "uvStatistics",
  data() {
    return {
      channel: undefined,
      uvStart: "",
      uvEnd: "",
      tableColumns: [
        {
          title: "访问时间",
          dataIndex: "hour",
          width: 150,
        },
        {
          title: "uv访问量",
          dataIndex: "uv",
          sorter: (a, b) => {
            return a.uv - b.uv;
          },
          width: 100,
        },
        {
          title: "uv注册量",
          dataIndex: "uvRegister",
          sorter: (a, b) => {
            return a.uvRegister - b.uvRegister;
          },
          width: 100,
        },
        {
          title: "注册成功率",
          dataIndex: "registerRate",
          sorter: (a, b) => {
            return a.registerRate - b.registerRate;
          },
          scopedSlots: { customRender: "registerRate" },
          width: 100,
        },
        {
          title: "交单量",
          dataIndex: "submit",
          width: 100,
        },
        {
          title: "交单率",
          dataIndex: "submitRate",
          width: 100,
        },
        {
          title: "成单",
          dataIndex: "remark",
          ellipsis: true,
        },
      ],
      tableDataSource: [],
      loadingTable: false,
      channelSelectList: [],
      startTime: null,
      endTime: null,
    };
  },
  computed: {
    lastLoginDateEndTime() {
      // 开始时间
      if (this.endTime) {
        return this.$common.transformTime(this.endTime);
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.startTime) {
        return this.$common.transformTime(this.startTime);
      }
      return "";
    },
  },
  mounted() {
    this.today();
    this.query(1);
    this.getChannelList();
  },
  methods: {
    ExportData() {
      location.href =
        process.env.VUE_APP_CURRENTMODE == "dev"
          ? process.env.VUE_APP_BASE_API
          : location.origin +
            `/api/manager/dailyReport/exportDailyChannelUv?channel=${this.channel}&uvStart=${this.uvStart}&uvEnd=${this.uvEnd}&startTime=${this.lastLoginDateStartTime}&endTime=${this.lastLoginDateEndTime}`;
    },
    today() {
      let startTime = new Date();
      startTime.setHours(0);
      startTime.setMinutes(0);
      startTime.setSeconds(0);
      startTime.setMilliseconds(0);
      let endTime = new Date();
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime.setSeconds(59);
      endTime.setMilliseconds(59);
      this.startTime = moment(startTime, "YYYY-MM-DD HH:mm:ss");
      this.endTime = moment(endTime, "YYYY-MM-DD HH:mm:ss");
    },
    getChannelList(channel) {
      analysisApi.channelList({ channel }).then((res) => {
        if (res.result == 200) {
          this.channelSelectList.splice(0);
          res.data.forEach((element, index) => {
            this.channelSelectList.push({ id: index + 1, name: element });
          });
        }
      });
    },
    // 点击查询
    query() {
      let data = {
        channel: this.channel,
        uvStart: this.uvStart,
        uvEnd: this.uvEnd,
        startTime: this.lastLoginDateStartTime,
        endTime: this.lastLoginDateEndTime,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data;
            this.tableDataSource.forEach((item, index) => {
              this.$set(item, "id", index + 1);
              this.$set(
                item,
                "registerRate",
                item.registerRate.split("%")[0] * 1
              );
            });
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.uvStatistics {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
